module.exports = __webpack_public_path__ + "static/media/singer-img2.e94dca34.png";